module.exports = __webpack_public_path__ + "static/media/94772307-doctor-in-hospital-background-with-copy-space-healthcare-and-medical-concept-.5c086362.png";